import React from 'react';
import styled from 'styled-components';

const TooltipContentContainer = styled.div`
  padding: 15px;
  h2 {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 12px;
    color: #adb5bd;
    margin-bottom: 9px;
  }

  p {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #4b4b4b;
    :not(:last-child) {
      margin-bottom: 7px;
    }
  }
`;

const ContentTooltip = ({ title, values }) => {
  if (!values) {
    values = [];
  }
  return (
    <TooltipContentContainer>
      {title && <h2>{title}</h2>}
      {values.map((value, index) => (
        <p key={index}>{value}</p>
      ))}
    </TooltipContentContainer>
  );
};

export default ContentTooltip;
